import React, { useEffect, useRef } from "react";

/**
 * Linear/Vercel-style cursor effect:
 *  - Soft radial sage spotlight that follows the cursor
 *  - Small outlined sage circle as a custom cursor with lerp trailing
 *  - On hover over [data-cursor="hover"] elements, cursor scales up & fills
 */
export const CursorFX = () => {
  const spotRef = useRef(null);
  const dotRef = useRef(null);
  const pos = useRef({ x: 0, y: 0 });
  const target = useRef({ x: 0, y: 0 });
  const raf = useRef(null);

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) return;

    const onMove = (e) => {
      target.current = { x: e.clientX, y: e.clientY };
      if (spotRef.current) {
        spotRef.current.style.setProperty("--mx", `${e.clientX}px`);
        spotRef.current.style.setProperty("--my", `${e.clientY}px`);
      }
    };

    const onOver = (e) => {
      const el = e.target.closest('[data-cursor="hover"], a, button');
      if (el && dotRef.current) dotRef.current.classList.add("cursor-hover");
    };
    const onOut = (e) => {
      const el = e.target.closest('[data-cursor="hover"], a, button');
      if (el && dotRef.current) dotRef.current.classList.remove("cursor-hover");
    };

    const tick = () => {
      pos.current.x += (target.current.x - pos.current.x) * 0.18;
      pos.current.y += (target.current.y - pos.current.y) * 0.18;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${pos.current.x}px, ${pos.current.y}px) translate(-50%, -50%)`;
      }
      raf.current = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);
    document.addEventListener("mouseout", onOut);
    raf.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseout", onOut);
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <>
      <div ref={spotRef} className="cursor-spotlight" aria-hidden="true" />
      <div ref={dotRef} className="custom-cursor" aria-hidden="true" />
    </>
  );
};

export default CursorFX;
